enum SelectType {
  ASYNC = 'async',
  NORMAL = 'normal',
  CREATABLE = 'creatable',
}

export default SelectType;
